/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataNotificationRegistrationSearchFilter } from './businessObjectDataNotificationRegistrationSearchFilter';


export interface BusinessObjectDataNotificationRegistrationSearchRequest { 
    /**
     * A list of business object data notification registration search filters
     */
    businessObjectDataNotificationRegistrationSearchFilters?: Array<BusinessObjectDataNotificationRegistrationSearchFilter>;
}
